__turbopack_context__.v({
  "fade-in": "Parallax-module-scss-module__Qf1__q__fade-in",
  "inner": "Parallax-module-scss-module__Qf1__q__inner",
  "isMounted": "Parallax-module-scss-module__Qf1__q__isMounted",
  "root": "Parallax-module-scss-module__Qf1__q__root",
});
